import { OktaConfigInterface } from './okta-config-interface';
import { oktaSharedConfig } from './okta-shared-config';


export const environment = {
  production: false,
  // Lets staff switch to the new SPARK experience (staff home, classrooms, live view). Off in prod until launch.
  sparkNewFlowToggle: true,
  parentPortalWebUrl: 'https://scholar-qa.mktg.nhatest.com',
  cmsBaseUrl: 'https://nhaschools-np.nhatest.com',
  apiUrl: 'https://app-qa.nhaschools.com/api',
  baseUrl: 'https://app-qa.nhaschools.com/',
  isDevelopment: true,
  capgoChannel: 'staging',
  showLoginDebugToggle: false,
  oktaConfig: {
    ...oktaSharedConfig,   
    scopes: ['openid', 'profile', 'email', 'phone', 'offline_access'],
    pkce: true,
    testing: {
      disableHttpsCheck: false // or true, depending on your need
    },
    devMode: true, // Enable debug mode for detailed logs
  } as OktaConfigInterface,
  // login type configurations
  oktaLoginTypes: {
    Staff: {
      clientId: '0oaw60abvdwQGMZcU4x7',
      issuer: 'https://sso.nhaschools.com/oauth2/default',
      redirectUri: 'com.nhaschools.app:/callback',
      signOutRedirectURI: 'com.nhaschools.app:/logout',
      authorize: 'https://sso.nhaschools.com/oauth2/default/v1/authorize',
      token: 'https://sso.nhaschools.com/oauth2/default/v1/token',
      userInfo: 'https://sso.nhaschools.com/oauth2/default/v1/userinfo'
    },
    Student: {
      clientId: '0oaw60abvdwQGMZcU4x7',
      issuer: 'https://sso.nhaschools.com/oauth2/default',
      redirectUri: 'com.nhaschools.app:/callback',
      signOutRedirectURI: 'com.nhaschools.app:/logout',
      authorize: 'https://sso.nhaschools.com/oauth2/default/v1/authorize',
      token: 'https://sso.nhaschools.com/oauth2/default/v1/token',
      userInfo: 'https://sso.nhaschools.com/oauth2/default/v1/userinfo'
    },
    Parent: {
      clientId: '0oap1y0rjrY60XgZa5d7',
      issuer: 'https://nhaparents.okta.com/oauth2/default',
      //redirectUri: window.location.origin + '/callback',
      redirectUri: 'https://app.nhaschools.com/callback',
      //signOutRedirectURI: 'https://nhaparents.okta.com/oauth2/default/v1/logout',
      signOutRedirectURI: 'com.nhaschools.app:/logout',
      authorize: 'https://nhaparents.okta.com/oauth2/default/v1/authorize',
      token: 'https://nhaparents.okta.com/oauth2/default/v1/token',
      userInfo: 'https://nhaparents.okta.com/oauth2/default/v1/userinfo'
    }
  }
};
